module.exports = __webpack_public_path__ + "static/media/sarahPic.8314214b.png";